<template>
	<div
			v-show="showStoreSelection"
			class="modal-wpr"
			:class="{ 'filter-panel-open': isFilterPanelOpen }"
	>

		<div class="modal">
			<div class="header">
				<h2>{{ content.storeLocator.selectStore }}</h2>
				<a class="close-btn" @click="closeStoreSelection()">
					<img alt="close" src="/images/icon-close-white.svg">
				</a>
			</div>

			<div class="content">
				<div class="store-searchbar-container">
					<input v-model="searchCityOrPostal" :placeholder="content.storeLocator.postalCodePlaceholder" type="text"
					       @keydown.enter="getNewStores()"/>
					<button :disabled="searchCityOrPostal.length<3" aria-label="search" class="search-icon"
					        @click="getNewStores()">
						<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g>
								<path
										d="M495,466.2L377.2,348.4c29.2-35.6,46.8-81.2,46.8-130.9C424,103.5,331.5,11,217.5,11C103.4,11,11,103.5,11,217.5   S103.4,424,217.5,424c49.7,0,95.2-17.5,130.8-46.7L466.1,495c8,8,20.9,8,28.9,0C503,487.1,503,474.1,495,466.2z M217.5,382.9   C126.2,382.9,52,308.7,52,217.5S126.2,52,217.5,52C308.7,52,383,126.3,383,217.5S308.7,382.9,217.5,382.9z"
										fill="currentColor"/>
							</g>
						</svg>
					</button>
				</div>
				<div v-if="showError" class="error-msg">{{ content.storeLocator.postalCodeRequirement }}
				</div>

				<div class="store-list-container">
					<div class="store-list">
						<svg v-if="loading" height="211px" preserveAspectRatio="xMidYMid" style="margin:auto;background:#fff;display:block;"
						     viewBox="0 0 100 100" width="211px" xmlns="http://www.w3.org/2000/svg"
						     xmlns:xlink="http://www.w3.org/1999/xlink">
							<circle :stroke="branding.secondaryColor" cx="50" cy="50" fill="none" r="26"
							        stroke-dasharray="122.52211349000194 42.840704496667314" stroke-width="3">
								<animateTransform attributeName="transform" dur="1s" keyTimes="0;1" repeatCount="indefinite"
								                  type="rotate" values="0 50 50;360 50 50"></animateTransform>
							</circle>
						</svg>
						<!--Store-->
						<div v-for="(store,index) in closestStores" v-else :key="index" class="store">
							<div>
								<div class="store-count">{{ index + 1 }}</div>
							</div>
							<div class="store-details">
								<h4>{{ store.storeName }}</h4>
								<div>{{ toTitleCase(store.address) }}<br>
									{{ toTitleCase(store.city) }}, {{ store.province }}
								</div>
								<button v-show="!isActive(store.storeNumber)"
								        @click="handleChangeStore(store.storeNumber)">{{ lang.storeLocator.select }}</button>
								<button v-if="isActive(store.storeNumber)" disabled>{{ lang.storeLocator.currentStore }}</button>
							</div>
							<a :href="getGoogleMapsUrl(store)" class="directions-link" target="_blank">
								<div class="directions-icon">
									<svg fill="none" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
										<path d="m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5ZM10 5.47l4 1.4v11.66l-4-1.4V5.47Zm-5 .99 3-1.01v11.7l-3 1.16V6.46Zm14 11.08-3 1.01V6.86l3-1.16v11.84Z"
										      fill="#545454"/>
									</svg>
								</div>
								<span>{{ store.distanceInKm }} km</span>
								<span>{{ lang.storeLocator.getDirections }}</span>
							</a>
						</div>
					</div>


				</div>
			</div>
		</div>

	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {toTitleCase} from "@/utils";
import PersistentData from "@/classes/PersistentData";
import Rest from "@/api/Rest";
import Lytics from "@/classes/Lytics";
import axios from "axios";
import {EVENT_STORE_LOCATOR_SELECT_STORE} from "@/features/store-locator/StoreLocatorEvents";
import featureMixin from "@/mixins/featureMixin";

export default {
	components: {},
	mixins:[featureMixin],
	props:{
		hardLoad: {
			type: Boolean,
			default: false
		},
		eventOnly: {
			type: Boolean,
			default: false
		},

	},
	data() {
		return {
			featurePath: 'storeLocator',
			searchCityOrPostal: '',
			showError: false,
			loading: false,
		}
	},
	computed: {
		...mapState('storeLocator', ['showStoreSelection', 'closestStores']),
		...mapState('toast', ['showHelp']),
		...mapState('landingPage', ['flyers']),
		...mapState(['currentStore', 'currentStoreObj']),
		...mapGetters('screen', ['displayMode']),
		...mapGetters('config', ['branding']),
		...mapGetters('filters', ['isFilterPanelOpen']),
		...mapGetters(['content', 'lang'])
	},
	watch: {
		showStoreSelection(isOpen) {
			if (isOpen) {
				if (this.showHelp) {
					this.toggleHelp(false);
				}
				Lytics.TriggerStoreSelectorOpen({
					store_id: this.currentStoreObj.storeNumber,
					store_name: this.currentStoreObj.storeName
				});
			}
		}
	},
	methods: {
		...mapActions('storeLocator', ['toggleStoreSelection', 'setCurrentLocation', 'fetchFiveClosestStores']),
		...mapActions('toast', ['toggleHelp']),
		...mapActions('landingPage', ['getFlyersData', 'setCurrentFlyer']),
		...mapActions(['setCurrentStore', 'setCurrentStoreObj']),
		...mapActions('events', ['triggerEvent']),
		toTitleCase,

		isActive(storeId) {
			return this.currentStore === parseInt(storeId);
		},

		getGoogleMapsUrl(store) {
			// Format: address, city, province postalCode
			const destination = `${store.address}, ${store.city}, ${store.province}`;
			const encodedDestination = encodeURIComponent(destination);
			return `https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`;
		},

		async getNewStores() {
			if (this.searchCityOrPostal.length < 3) {
				this.showError = true
				return;
			}

			if (!this.searchCityOrPostal.trim()) return;

			try {
				this.loading = true;
				const response = await axios.get('https://geoproxy-ghafe8ggfug4c7ba.canadacentral-01.azurewebsites.net/api/GeoProxy', {
					params: {
						code: 'eDxjR1-wI4vJ5FSCD1Vhy-GIHGJ6jnKz79uoT9wuyxdcAzFuEo560g==',
						address: `${this.searchCityOrPostal}${this.config?.appendToGeolocation || ''}`,
					},
				});
				console.log('store locator', this.config)

				if (response.data && response.data.results && response.data.results.length > 0) {
					const {lat, lng} = response.data.results[0].geometry.location;
					this.setCurrentLocation({lat: parseFloat(lat), lng: parseFloat(lng)})
					this.showError = false;
					// pass this to stores api to fetch nearest 5 stores
					await this.fetchFiveClosestStores()
					this.loading = false;
				} else {
					this.showError = true;
					this.loading = false;
				}
			} catch (error) {
				console.error('Geocoding error:', error);
				this.showError = true;
				this.loading = false;
			}
		},

		closeStoreSelection() {
			this.toggleStoreSelection(false);
		},
		async handleChangeStore(storeid) {
			const currentStore = this?.closestStores?.find(store => store?.storeNumber === storeid)
			Lytics.TriggerStoreSelectorSelect({
				store_id: currentStore.storeNumber,
				store_name: currentStore.storeName
			});

			const rt = this.$router.resolve({
				name: "Flyer",
				query: {
					...this.$route.query,
					storeId: storeid
				}
			})

			const pd = new PersistentData('storeLocator');
			pd.setData('storeID', currentStore.storeNumber)
			pd.setData('store', currentStore)
			pd.setData('route', rt)

			this.triggerEvent({event: EVENT_STORE_LOCATOR_SELECT_STORE, data: {store: currentStore, route: rt}})

			if(this.eventOnly) {
				return;
			}

			this.setCurrentStoreObj(currentStore)
			const lat = this.currentStoreObj.latitude
			const lng = this.currentStoreObj.longitude
			this.setCurrentLocation({lat, lng})
			this.setCurrentStore(parseInt(storeid))
			this.closeStoreSelection()

			if(this.hardLoad) {
				window.location.assign(rt.href);
				return;
			} else {
				await this.$router.push(rt)
			}

			await this.getFlyersData(parseInt(storeid));
			this.$root.$emit('store-change', storeid);
			if (!this.flyers.find(flyer => flyer.title === this.$route.params.flyerId)) {
				await Rest.NavigateToFlyer(this.currentFlyer.title);
			}


		}
	},

}
</script>

<style lang="scss" scoped>

.modal-wpr {

  --scroll-bar-width: 10px;
  --scroll-bar-thumb-size: 135px;
  --scroll-bar-track-margin: 67.5px;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;


  .modal {
	position: relative;
	background-color: #FFF;
	border: 1px solid #BBBBBB;
	border-radius: 4px;
	max-height: calc(100% - 9.5em);
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	flex-flow: column;
	min-width: 60rem;

	.header {
	  background-color: var(--secondary-color);
	  color: var(--primary-text-color);
	  display: flex;
	  justify-content: space-between;
	  padding: 10px;

	  h2 {
		font-size: 18px;
		font-weight: 400;
		color: white;
	  }

	  .close-btn {
		cursor: pointer;
	  }
	}

	.content {
	  padding: 1em;
	  overflow-y: auto;
	  overflow-x: hidden;

	  .store-searchbar-container {
		position: relative;

		input {
		  height: 2.5em;
		  padding: 1em;
		  border: 0.5px solid lightgrey;
		  border-radius: 5px;
		  width: 100%;
		}

		.search-icon {
		  width: 30px;
		  color: #fff;
		  background-color: var(--secondary-color);
		  border: none;
		  border-radius: 4px;
		  position: absolute;
		  right: 0;


		  svg {
			width: 80%
		  }
		}
	  }

	  .error-msg {
		color: #EE3124;
		margin-bottom: 1em;
	  }


	  .store-list-container {
		display: flex;
		width: 100%;
		max-height: calc(100% - 40px);
		min-height: 670px;
		margin-top: 0.5em;
		justify-content: stretch;

		.store-list {
		  display: flex;
		  flex-direction: column;
		  padding: 0.2em;
		  overflow-y: auto;
		  width: 100%;

		  .store {
			display: flex;
			padding: 5px 0 0 5px;
			border-radius: 5px;

			.store-count {
			  background: #BBBBBB;
			  border-radius: 16%;
			  padding: 0.2em;
			  margin-right: 1em;
			  flex-basis: 10%;
			  margin-bottom: 5px;
			  flex-direction: row;
			  width: 40px;
			  height: 40px;
			  display: grid;
			  place-items: center;
			}

			.store-details {
			  h4 {
				color: var(--secondary-color);
			  }

			  button {
				margin: 10px 0;
				background: var(--secondary-color);
				color: white;
				padding: 0.5em;
				width: 8em;
			  }
			}

			.directions-link {
			  .directions-icon {
				background-color: #D8D8D8;
				padding: 9px 12px;
				height: 42px;
				border-radius: 4px;
				margin-bottom: 10px;
			  }

			  display: flex;
			  flex-direction: column;
			  align-items: center;
			  max-width: 81px;
			  text-align: center;
			  margin: 8px 0;
			  margin-left: auto;
			  color: var(--secondary-color);
			  text-decoration: underline;
			  font-size: 14px;
			  line-height: 1.4;

			  &:hover {
				opacity: 0.8;
			  }
			}
		  }

		  .store:hover {
			background: #ededed;
		  }

		  .store:not(:last-child) {
			border-bottom: 1px solid lightgrey;
		  }
		}

		.map {
		  flex-basis: 60%;
		  border: 0.5px solid gray;
		  text-align: center;
		}
	  }

	}
  }
}

//Mobile
@media (max-width: 768px) {
  .modal-wpr .modal {
    max-height: 60vh !important;
    margin: 1em 2.8em;
    min-width: 90vw;
  }
  .modal-wpr.filter-panel-open .modal {
    top: 5rem;
  }
  .modal-wpr .modal .content .store-list-container .store-list {
    flex-basis: 100%;
  }
}

// Tablet
@media (min-width: 768px) and (max-width: 1024px) {
  .modal-wpr .modal {
    max-height: 70vh !important;
    min-width: 40em;
  }

  .modal-wpr.filter-panel-open .modal {
    top: 3rem;
  }

  .modal-wpr .modal .content .store-list-container .store-list {
    flex-basis: 100%;
  }
}

</style>
